export const HIDDE_REGISTER_FORM = 'HIDDE_REGISTER_FORM';
export const SHOW_REGISTER_FORM = 'SHOW_REGISTER_FORM';
export const SHOW_LOGIN_FORM = 'SHOW_LOGIN_FORM';
export const HIDDE_LOGIN_FORM = 'HIDDE_LOGIN_FORM';
export const SHOW_FORM = 'SHOW_FORM';
export const SHOW_RECOVER_PASSWORD = 'SHOW_RECOVER_PASSWORD';
export const HIDDE_RECOVER_PASSWORD = 'HIDDE_RECOVER_PASSWORD';
